import React, {useState} from 'react';
import {Container, Row, Col, Card} from 'react-bootstrap';
import logo from './logo.svg';
import './App.css';
import NavBar from './components/Nav';
import Graph from './components/Chart';
import Inputs from './components/Inputs';
import Table from './components/Table';
import ImageUpload from './components/images';
import ImportFromFile from './components/FileReader';
import BarGraph from './components/BarGraph';
import ControlledCarousel from './components/Carousel';
import PieGraph from './components/PieChart';
import ReactGA from 'react-ga';



function App() {
 const [data, setData] = useState([]);
 const [displayLegend, setDisplayLegend] = useState(true);
 const [displayTitle, setDisplayTitle] = useState(true);
 const [animation, setAnimation] = useState(false);
 const [zero, setZero] = useState(true);
 const [title, setTitle] = useState("");
 const [chartType, setChartType] = useState("line");
 const [fill, setFill] = useState(false);
 const [lineColor, setLineColor] = useState("gray");
 const [bezierCurve, setBezierCurve] = useState(false);
 const [displayValues, setDisplayValues] = useState(true);
 const [base64Href, setBase64Href] = useState("");
 const [image, setImage] = useState([]);
 const [startMode, setStartMode] = useState(true);
 const [useImage, setUseImage] = useState(false);
 const [width,setWidth] = useState(50);
 const [height, setHeight] = useState(50);
 const [labelType, setLabelType] = useState('label');
 const [pattern, setPattern] = useState("none");
 const [fillPattern, setFillPattern] = useState("none");
 const [fillColor, setFillColor] = useState("gray");


 ReactGA.initialize('UA-111861975-2');
 ReactGA.pageview("Home")

  const addData = (obj) => {
    setData(data => [...data, JSON.stringify(obj)])
    // setImage([...image, obj.image])
    // localStorage.setItem("images", image);
    // console.log("Hello World:" + JSON.stringify(localStorage.getItem("images")));
  }

  const deleteData = (item, id) => {
    setData(data.filter((item, index) => id !== index))
  }

  const displayLegendToggle = () => {
    setDisplayLegend(!displayLegend);
  }

  const displayTitleToggle = () => {
    setDisplayTitle(!displayTitle);
  }

  const settingAnimation = () => {
    setAnimation(!animation);
  }

  const settingZero = () => {
    setZero(!zero);
  }

  const settingTitle = (title) => {
    setTitle(title);
  }

  const settingChartType= (type) => {
    setChartType(type);
  }

  const settingFill = () => {
    setFill(!fill);
  }

  const settingLineColor = (color) => {
    setLineColor(color);
  }

  const settingFillColor = (color) => {
    setFillColor(color);
  }

  const settingBezierCurve = () => {
    setBezierCurve(!bezierCurve);
  }

  const settingDisplayValues = () => {
    setDisplayValues(!displayValues);
  }

  const settingImage = (img) => {
    setImage(img);
  }

  const settingUseImage = () => {
    setUseImage(!useImage);
  }

  const settingWidth = (width) => {
    setWidth(width);
  }

  const settingHeight = (height) => {
    setHeight(height);
  }

  const settingLabelType = (label) => {
    setLabelType(label);
  }

  const settingPattern = (pattern) => {
    setPattern(pattern);
  }

  const settingFillPattern = (pattern) => {
    setFillPattern(pattern);
  }



  const csvData = (labels, values, colors) => {
    for (var i =0; i < labels.length; i++){
      var obj = {label: labels[i], value: values[i], color: colors[i], image:"", pattern: "none"}
      addData(obj);
    }
  }


  return (
    <div className="App">  
          <NavBar />
          <Container>
           {startMode ? <br /> : <a className="btn btn-primary" href={base64Href} style={{margin:"8px"}} download="chart.png">Download PNG</a>}
            <Row>
              <Col>
              {startMode ? 
                  <Card style={{maxHeight:"500px", marginBottom: "16px", minHeight: "500px"}}>
                  <Card.Body>
                          <div style={{minHeight: "400px"}}>
                            <h3>Welcome to Charty McChart Chart</h3>
                            <p>Charty's goal is to provide a free resource to make visually appealing graphs. </p>
                            <p>Add Images, patterns, curves, fills and more with Charty McChart Chart!</p>
                            <p>To create a new chart, click <strong>Chart Type Options</strong> below</p>
                            <p>When you're done, click <strong>Download PNG</strong> at the top to download the file, Happy Charting!</p>
                            <ControlledCarousel />
                        </div>
                    
                  </Card.Body>
                  </Card>: ""}
              {/* {chartType === 'bar' && !startMode ? 
              <BarGraph data={data} 
                     width={data.map(item => JSON.parse(item).width)} 
                     height={data.map(item => JSON.parse(item).height)}
                     labels={data.map(item => JSON.parse(item).label)} 
                     values={data.map(item => JSON.parse(item).value)}
                     colors={data.map(item => JSON.parse(item).color)}
                     images={data.map(item => JSON.parse(item).image)}
                     displayLegend={displayLegend}
                     displayTitle={displayTitle}
                     animation={animation}
                     zero={zero}
                     title={title}
                     chartType={chartType}
                     fill={fill}
                     lineColor={lineColor}
                     bezierCurve={bezierCurve}
                     displayValues={displayValues}
                     base64Href={base64Href} 
                     setBase64Href={setBase64Href}
                     />: 
                     ''} */}
              {chartType !== 'line' && !startMode ? 
              <PieGraph data={data} 
                     width={data.map(item => JSON.parse(item).width)} 
                     height={data.map(item => JSON.parse(item).height)}
                     labels={data.map(item => JSON.parse(item).label)} 
                     values={data.map(item => JSON.parse(item).value)}
                     colors={data.map(item => JSON.parse(item).color)}
                     images={data.map(item => JSON.parse(item).image)}
                     patterns={data.map(item => JSON.parse(item).pattern)}
                     displayLegend={displayLegend}
                     displayTitle={displayTitle}
                     animation={animation}
                     zero={zero}
                     title={title}
                     chartType={chartType}
                     fill={fill}
                     lineColor={lineColor}
                     bezierCurve={bezierCurve}
                     displayValues={displayValues}
                     base64Href={base64Href} 
                     setBase64Href={setBase64Href}
                     labelType={labelType}
                     
                     />: 
                     ''}
              {chartType === 'line' && !startMode  ? 
              <Graph data={data} 
                     labels={data.map(item => JSON.parse(item).label)} 
                     values={data.map(item => JSON.parse(item).value)}
                     colors={data.map(item => JSON.parse(item).color)}
                     images={data.map(item => JSON.parse(item).image)}
                     patterns={data.map(item => JSON.parse(item).pattern)}
                     displayLegend={displayLegend}
                     displayTitle={displayTitle}
                     animation={animation}
                     zero={zero}
                     title={title}
                     chartType={chartType}
                     fill={fill}
                     lineColor={lineColor}
                     bezierCurve={bezierCurve}
                     displayValues={displayValues}
                     base64Href={base64Href} 
                     setBase64Href={setBase64Href} 
                     startMode={startMode}
                     settingFillPattern={settingFillPattern}
                     fillPattern={fillPattern}
                     fillColor={fillColor}
                     />:
                    ''}
              </Col>
            </Row>
            <Row>
              <Col>
                <Inputs addData={addData} 
                      displayLegendToggle={displayLegendToggle}
                      displayTitleToggle={displayTitleToggle}
                      settingAnimation={settingAnimation}
                      settingZero={settingZero}
                      title={title}
                      settingTitle={settingTitle}
                      settingChartType={settingChartType}
                      settingFill={settingFill}
                      settingLineColor={settingLineColor}
                      settingBezierCurve={settingBezierCurve}
                      settingDisplayValues={settingDisplayValues}
                      data={data}
                      deleteData={deleteData}
                      lineColor={lineColor}
                      csvData={csvData}
                      settingImage={settingImage}
                      displayLegend={displayLegend}
                     displayTitle={displayTitle}
                     animation={animation}
                     zero={zero}
                     fill={fill}
                     bezierCurve={bezierCurve}
                     setStartMode={setStartMode}
                     chartType={chartType}
                     settingUseImage={settingUseImage}
                     useImage={useImage}
                     settingWidth={settingWidth}
                     settingHeight={settingHeight}
                     width={width}
                     height={height}
                     settingLabelType={settingLabelType}
                     labelType={labelType}
                     settingPattern={settingPattern}
                     pattern={pattern}
                     settingFillPattern={settingFillPattern}
                     settingFillColor={settingFillColor}
                     fillColor={fillColor}/>
                </Col>
            </Row>
            <Row>
            {/* <ImageUpload settingImage={settingImage}/> */}
             {/* <ImageUpload />
             <ImageUpload />
             <ImageUpload /> */}
            </Row>
          </Container>
    </div>
  );
}

export default App;
